var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"mb-4"},[_vm._v(" Page Not Found! ")]),_c('v-btn',{attrs:{"href":"/","large":""}},[_vm._v("Back to main page")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }